module.exports = __webpack_public_path__ + "static/media/ic_admin.2e7eb186.png";